export const colorOptions: Record<string, string> = {
  Blue: "bg-blue-600 text-white border-blue-600",
  DodgerBlue: "bg-[#1E90FF] text-white border-[#1E90FF]",
  Green: "bg-green-600 text-white border-green-600",
  Purple: "bg-purple-600 text-white border-purple-600",
  Orange: "bg-orange-600 text-white border-orange-600",
  Pink: "bg-pink-600 text-white border-pink-600",
  Teal: "bg-teal-600 text-white border-teal-600",
  Yellow: "bg-yellow-600 text-black border-yellow-600",
  Indigo: "bg-indigo-600 text-white border-indigo-600",
  Amber: "bg-amber-600 text-black border-amber-600",
  Lime: "bg-lime-600 text-black border-lime-600",
  Fuchsia: "bg-fuchsia-600 text-black border-fuchsia-600",
  Rose: "bg-rose-500 text-white border-rose-700",
  Sky: "bg-sky-600 text-white border-sky-600",
  Emerald: "bg-emerald-600 text-white border-emerald-600",
  Slate: "bg-slate-600 text-white border-slate-800",
  Zinc: "bg-zinc-600 text-white border-zinc-800",
  Stone: "bg-stone-600 text-white border-stone-800",
  Neutral: "bg-neutral-600 text-white border-neutral-800",
};

export const SidebarThemeClass: Record<string, string> = {
  Blue: "bg-blue-100 text-black border-blue-300",
  DodgerBlue: "bg-[#1E90FF]/10 text-black border-[#1E90FF]/50",
  Green: "bg-green-100 text-black border-green-300",
  Purple: "bg-purple-100 text-black border-purple-300",
  Orange: "bg-orange-100 text-black border-orange-300",
  Pink: "bg-pink-50 text-black border-pink-300",
  Teal: "bg-teal-100 text-black border-teal-300",
  Yellow: "bg-yellow-100 text-black border-yellow-300",
  Indigo: "bg-indigo-100 text-black border-indigo-300",
  Amber: "bg-amber-100 text-black border-amber-300",
  Lime: "bg-lime-100 text-black border-lime-300",
  Fuchsia: "bg-fuchsia-100 text-black border-fuchsia-300",
  Rose: "bg-rose-100 text-black border-rose-300",
  Sky: "bg-sky-100 text-black border-sky-300",
  Emerald: "bg-emerald-100 text-black border-emerald-300",
  Slate: "bg-slate-100 text-black border-slate-600",
  Zinc: "bg-zinc-100 text-black border-zinc-600",
  Stone: "bg-stone-100 text-black border-stone-600",
  Neutral: "bg-neutral-100 text-black border-neutral-600",
};
//  { color: "#1E90FF", name: "DodgerBlue" },

export const textColorOptions: Record<string, string> = {
  Blue: "text-blue-600",
  DodgerBlue: "text-[#1E90FF]",
  Green: "text-green-600",
  Purple: "text-purple-600",
  Orange: "text-orange-600",
  Pink: "text-pink-600",
  Teal: "text-teal-600",
  Yellow: "text-yellow-600",
  Indigo: "text-indigo-600",
  Amber: "text-amber-600",
  Lime: "text-lime-600",
  Fuchsia: "text-fuchsia-600",
  Rose: "text-rose-500",
  Sky: "text-sky-600",
  Emerald: "text-emerald-600",
  Slate: "text-slate-600",
  Zinc: "text-zinc-600",
  Stone: "text-stone-600",
  Neutral: "text-neutral-600",
  DarkGray: "text-gray-800 ",
};
export const borderHighlightOptions: Record<string, string> = {
  Blue: "border-blue-600 ring-blue-400",
  DodgerBlue: "border-[#1E90FF] ring-[#1E90FF]",
  Green: "border-green-600 ring-green-400",
  Purple: "border-purple-600 ring-purple-400",
  Orange: "border-orange-600 ring-orange-400",
  Pink: "border-pink-600 ring-pink-400",
  Teal: "border-teal-600 ring-teal-400",
  Yellow: "border-yellow-600 ring-yellow-400",
  Indigo: "border-indigo-600 ring-indigo-400",
  Amber: "border-amber-600 ring-amber-400",
  Lime: "border-lime-600 ring-lime-400",
  Fuchsia: "border-fuchsia-600 ring-fuchsia-400",
  Rose: "border-rose-500 ring-rose-400",
  Sky: "border-sky-600 ring-sky-400",
  Emerald: "border-emerald-600 ring-emerald-400",
  Slate: "border-slate-600 ring-slate-400",
  Zinc: "border-zinc-600 ring-zinc-400",
  Stone: "border-stone-600 ring-stone-400",
  Neutral: "border-neutral-600 ring-neutral-400",
};

export const fontOptions: Record<string, string> = {
  "Franklin Gothic Medium": "Franklin Gothic Medium",
  "Sans-serif": "font-sans",
  Serif: "font-serif",
  Monospace: "font-mono",
  Thin: "font-thin",
  "Extra Light": "font-extralight",
  Light: "font-light",
  Normal: "font-normal",
  Medium: "font-medium",
  "Semi Bold": "font-semibold",
  Bold: "font-bold",
  "Extra Bold": "font-extrabold",
  Black: "font-black",
  Italic: "italic",
  Uppercase: "uppercase",
  Lowercase: "lowercase",
  Capitalize: "capitalize",
  "Tracking Tight": "tracking-tight",
  "Tracking Wide": "tracking-wide",
  "Text Shadow": "shadow-lg",
  "Small Caps": "tracking-widest uppercase text-xs",
  "Loose Spacing": "tracking-wider",
};

export const defaultTheme = {
  backgroundColor: colorOptions["DodgerBlue"],
  fontColor: "white",
  fontFamily: fontOptions["Sans-serif"],
};
